export default __webpack_public_path__ + "static/media/property_76.4c80e29a.png";